import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  error: null,
  saveMessage: null,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SCHOOL_SITE_ORDER_FETCHING:
      return { ...state, fetching: payload };

    case types.SCHOOL_SITE_ORDER_SET_ERROR:
      return { ...state, error: payload };

    case types.SCHOOL_SITE_ORDER_SET_SAVE_MESSAGE:
      return { ...state, saveMessage: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/schoolsiteorder/state/reducer.js